/**
 * Copyright 2016 Taito United Oy
 * All rights reserved.
 */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { FormattedHTMLMessage } from 'react-intl';

// Styles
import './styles/GoogleLogin.scss';

// Messages
import messages from './messages/GoogleLogin_messages';

const propTypes = {
  google: PropTypes.object.isRequired,
  clientId: PropTypes.string.isRequired,
  onLogin: PropTypes.func.isRequired,
};

class GoogleLogin extends PureComponent {
  componentDidMount() {
    this.props.google.load('auth2', () => {
      const auth2 = this.props.google.auth2.init({
        client_id: this.props.clientId,
      });

      const element = document.getElementById('google-login-button');
      auth2.attachClickHandler(
        element,
        {},
        response => {
          this.props.onLogin({
            provider: 'google',
            token: response.getAuthResponse().id_token,
          });
        },
        error => {
          console.error(error);
        }
      );

      auth2.currentUser.listen(user => {
        if (user.isSignedIn()) {
          this.props.onLogin({
            provider: 'google',
            token: user.getAuthResponse().id_token,
          });
        }
      });
    });

    // TODO: configure button
    // this.props.google.signin2.render('google-login-button', {
    //   onsuccess: (response) => {
    //     this.props.onLogin({
    //       provider: 'google',
    //       token: response.getAuthResponse().id_token,
    //     });
    //   },
    //   theme: 'dark',
    // });
  }

  render() {
    return (
      <div styleName="GoogleLogin">
        <a
          styleName="button"
          style={{ marginTop: 10 }}
          onClick={this._onLoginClick}
          id="google-login-button"
        >
          <div styleName="button-text">
            <i className="fa fa-google" styleName="icon" />
            <span style={{ marginRight: 20 }}>
              <FormattedHTMLMessage
                {...messages.loginButton}
                info="Login button"
              />
            </span>
          </div>
        </a>
      </div>
    );
    // return (
    //   <div
    //     style={{ marginTop: 15 }}
    //     id='google-login-button'
    //   ></div>
    // );
  }
}

GoogleLogin.propTypes = propTypes;

export default GoogleLogin;
